import { render } from "./Projet.vue?vue&type=template&id=24fb5a92&scoped=true"
import script from "./Projet.vue?vue&type=script&lang=js"
export * from "./Projet.vue?vue&type=script&lang=js"

import "./Projet.vue?vue&type=style&index=0&id=24fb5a92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fb5a92"]])

export default __exports__